// Remove disable eslint once additional constant is added
/* eslint-disable import/prefer-default-export */
export const CUSTOMER_PORTAL = 'Customer Portal';
